
export const FETCH_LOGIN = 'FETCH_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILS = 'LOGIN_FAILS';

export const REMOVE_AUTH_DETAILS = 'REMOVE_AUTH_DETAILS';